export default "__VITE_ASSET__YTWSeXP0__"